import  { SsmAdsBeitou } from "./ssm-ads-beitou";
require ("../../core/common.ts");
require("./beitou.scss");
$(document).ready(function(){
    let beitou = new SsmAdsBeitou('beitouad');
    beitou.init();
    //let beitou2 = new SsmAdsBeitou('beitouad2','aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa','bbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb');
    //beitou2.init();
});